module.exports = __webpack_public_path__ + "img/icono-alert.f53585ca.svg";